export default __webpack_public_path__ + "static/media/hammer.07f35460.png";